import React, { useMemo } from 'react';
import { Flex, Box } from 'reflexbox';
import { Container, styled } from '@teko/ui';
import { SideNav, UserCard } from '@teko/ecommerce';
import { useGlobalData } from '../../contexts';
import { useRouter } from 'next/router';
import { useAuth } from '@teko/auth-react';
import { getNavItems } from 'helpers/navigation-bar';

export interface AccountLayoutProps {
  children: React.ReactNode;
  hiddenUserNavItems?: boolean;
}
const SideBar = styled.div`
  padding-right: 1rem;
`;

const StyledContainer = styled(Container)`
  min-height: 77vh;
`;

export const AccountLayout: React.FunctionComponent<AccountLayoutProps> = ({
  children,
  hiddenUserNavItems,
}: AccountLayoutProps) => {
  const { user } = useAuth();
  const { tenant, notification, getProcessEnv } = useGlobalData();
  const router = useRouter();
  const loyaltyClientId = getProcessEnv('LOYALTY_CLIENT_ID');
  const navItems = useMemo(() => {
    return getNavItems({
      tenant,
      logged: !!user?.userId,
      isLoyaltyMember: !!loyaltyClientId,
      showNotificationItem: notification,
    });
  }, [tenant, user]);

  return (
    <StyledContainer mb={3} mt={3}>
      <Flex flexWrap="wrap">
        <Box width={[1, 1 / 3, 1 / 5]}>
          {!hiddenUserNavItems && (
            <SideBar>
              {!!user?.userId && (
                <UserCard
                  name={user?.name || user?.telephone}
                  picture={user?.avatar}
                />
              )}
              <SideNav
                activeHref={router.asPath || router.pathname}
                navItems={navItems}
              />
            </SideBar>
          )}
        </Box>
        <Box width={[1, 2 / 3, 4 / 5]}>{children}</Box>
      </Flex>
    </StyledContainer>
  );
};
